// Valori publice (cheia publishable nu da acces fara login; RLS-ul decide). Suprascrise la build
// cu VITE_*, daca sunt setate (testul cap-coada le seteaza spre Supabase-ul local).
export const SUPABASE_URL =
  import.meta.env.VITE_SUPABASE_URL ?? 'https://bhblmzhfzgstmaefxhwm.supabase.co';
export const SUPABASE_PUBLISHABLE_KEY =
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ?? 'sb_publishable_HerWDnnlXy4whM5t5DqDcg_3BGq8wVk';
/** Cheia de site Cloudflare Turnstile (publica). Goala = fara captcha la inregistrare. */
export const TURNSTILE_SITE_KEY = import.meta.env.VITE_TURNSTILE_SITE_KEY ?? '';

/**
 * Operatorul serviciului (paginile legale, subsolul). DE COMPLETAT inainte de lansare
 * (docs/22 §7): denumirea firmei, CUI-ul, adresa, emailul pentru date personale.
 */
export const OPERATOR = {
  name: import.meta.env.VITE_OPERATOR_NAME ?? '[Denumirea operatorului]',
  cui: import.meta.env.VITE_OPERATOR_CUI ?? '[CUI]',
  address: import.meta.env.VITE_OPERATOR_ADDRESS ?? '[Adresa sediului]',
  email: import.meta.env.VITE_OPERATOR_EMAIL ?? '[email de contact]',
};
